import React from 'react';
import Joi from 'joi-browser';
import Form from './common/form';
import Spinner from './common/spinner';

class MMIQueryForm extends Form {
	state = {
		data: {
			code: '',
		},
		errors: {},
	};

	schema = {
		code: Joi.string().min(25).max(27).required().label('Code'),
	};

	doSubmit = () => this.props.onSubmit(this.state.data);

	componentWillUnmount() {
		// fix Warning: Can't perform a React state update on an unmounted component
		this.setState = (state, callback) => {
			return;
		};
	}

	render() {
		const { isLoading, theme } = this.props;

		return (
			<form
				className='row'
				onSubmit={this.handleSubmit}>
				<div className='col-md-6 offset-md-3 col-12 text-start'>
					<div className='mt-4'>
						{this.renderInput({
							name: 'code',
							label: 'Please enter MMI code:',
							type: 'text',
						})}
					</div>

					<div className='my-3 text-center'>
						{this.renderButton(
							'Search',
							`btn btn-set2-${theme}`,
							isLoading && <Spinner content='Searching...' />
						)}
					</div>
				</div>
			</form>
		);
	}
}

export default MMIQueryForm;
